import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../state'

import * as scenario from './scenario'

/**
 * TODO: Js doc
 */
@ngCore.Component({
  // TODO: why?
  changeDetection: ngCore.ChangeDetectionStrategy.OnPush,
  imports: [scenario.Component],
  selector: 'atn-scenario-dropdown-overlay-section',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** TODO: Js doc */
  public readonly sectionSg =
    ngCore.input.required<state.routeBound.scenarios.models.Section.WithScenarios>(
      { alias: 'section' },
    )
  /** TODO:  */
  public readonly sectionIdSg = ngCore.computed(() => this.sectionSg().id)

  public readonly isSectionExpandedSg = ngCore.computed(() =>
    this.scenariosFeature.selectors
      .isSectionExpanded({ sectionId: this.sectionIdSg() })
      .asSignal(),
  )
  /** TODO:  */
  public readonly sectionScenariosSg = ngCore.computed(
    (section = this.sectionSg()) => section.scenarios,
  )
  /** TODO:  */
  public toggleSectionBtnClickHandler() {
    this.scenariosFeature.actions.toggleSectionCollapsed
      .from(
        `ScenarioOverlay.Section-${this.sectionIdSg()}.Buttons.Toggler.Clicked`,
      )
      .dispatch({
        section: this.sectionSg(),
      })
  }
}
